import { Box } from "@mui/material"

import {
	DispatchProductDetailPageReducer,
	ProductDetailPageReducerState,
} from "@secureo/common/reducers/productDetailPageReducer"
import setSafeVariant from "@secureo/common/reducers/productDetailPageReducer/actions/safes/setSafeVariant"

import useTranslation from "hooks/useTranslation"

const ColorSelect = ({ reducerState, dispatch, language }: Props) => {
	const { t } = useTranslation("product")
	const {
		variantId,
		variantsByVariantId,
		colorsBySafeLockConfigurationProductSku,
		selectedSafeLockConfigurationProduct,
		isLoading,
	} = reducerState

	const selectedColor = variantsByVariantId[variantId]?.attributes?.colorConfigurationHexCode
	const selectedColorName = variantsByVariantId[variantId]?.attributes?.colorConfigurationName

	const colors = colorsBySafeLockConfigurationProductSku[selectedSafeLockConfigurationProduct.sku]

	const setSafeColor = (variantId: number) => {
		setSafeVariant(dispatch, reducerState, variantId)
	}

	return (
		<Box mb={2} style={{ maxWidth: 350 }}>
			<div style={{ color: "#000000" }}>
				<strong>{t("color")}: </strong>{" "}
				{selectedColorName?.[language] ?? selectedColorName?.de}
			</div>
			<div style={{ display: "flex" }}>
				{colors.map((color) => {
					const { colorConfigurationHexCode, variantId } = color
					const isSelected = colorConfigurationHexCode === selectedColor

					return (
						<button
							disabled={isLoading}
							value={variantId}
							key={colorConfigurationHexCode}
							onClick={() => setSafeColor(variantId)}
							style={{
								borderRadius: 3,
								padding: 0,
								marginRight: 5,
								border: isSelected ? "2px solid #01B2C4" : "2px solid transparent",
								cursor: "pointer",
							}}
						>
							<div
								style={{
									width: 60,
									height: 60,
									margin: 2,
									background: colorConfigurationHexCode,
								}}
							/>
						</button>
					)
				})}
			</div>
		</Box>
	)
}

interface Props {
	dispatch: DispatchProductDetailPageReducer
	reducerState: ProductDetailPageReducerState
	language: string
}

export default ColorSelect
